import { DocumentTaxonomy } from "@common/documentCategories";

export function isUncategorizedDocumentTaxonomy(
    taxonomy: DocumentTaxonomy,
): boolean {
    return taxonomy === DocumentTaxonomy.uncategorized;
}
